import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function FullBoard(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_368_65)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M1.189.058a1 1 0 011.043.235l7.14 7.14.447-.557c-.92-1.206-1.125-2.985.014-4.383.458-.562 1.147-1.31 1.984-1.82.838-.51 2.29-1.027 3.743-.12a3.016 3.016 0 011.354 1.872c.166.687.08 1.336-.042 1.826-.242.963-.779 1.883-1.196 2.515-1.012 1.532-2.805 1.868-4.255 1.309l-.626.782 1.46 1.46a7.5 7.5 0 11-1.485 1.344l-1.232-1.233-5.757 7.197a1 1 0 11-1.562-1.25l5.896-7.37-.59-.59-2.293 2.292a1 1 0 01-1.46-.049C1.87 8.483 1.062 6.046.728 4.176A14.506 14.506 0 01.5 1.858c0-.038 0-.078-.002-.117C.487 1.099.472.314 1.19.058zm1.46 3.48c.222 1.427.752 3.252 1.963 4.96L6.111 7 2.649 3.538zM16.5 11a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm-2.25 3.5a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-2.25v1.25H18a.75.75 0 010 1.5h-2.25v1.5a.75.75 0 01-1.5 0v-5zM11.383 3.757c.821-1.007 2.072-2.16 3.117-1.507 1.04.65.275 2.25-.493 3.414-.516.782-1.583.875-2.315.29-.683-.547-.862-1.519-.309-2.197z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_368_65"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default FullBoard;